import React, { useCallback, useEffect, useState } from 'react'
import { useViewComparisonByYearQuery } from '../../../store/auth/authService'; 
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Spinner, Typography } from '@material-tailwind/react';
import TableLayout from '../../../layouts/pagesLayouts/TableLayout';
import { isIterableArray, saveGraphToPicture, toFormatPrice } from '../../../utils/utils';
import GraphConsumption from '../viewConsumption/GraphConsumption';
import { classCharWithDoughtnutContainerHeight, isShowInLegend, topLabels, isData } from '../common';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import ViewByPeriodDetailing from '../viewDoughnutByPeriod/ViewByPeriodDetailing';
import FiltersViewComparison from './FiltersViewComparison';
import { baseApi } from '../../../ConfigApi';
import axios from 'axios';
import { errorToast, successToast } from '../../../components/toasts/toasts';
import fileDownload from 'js-file-download';
import { chartColors } from '../../../utils/variables';
import { ConsFormType } from '../common.types';

const GRAPH_ID = "js-comparison-by-year-graph"
const GRAPH_DOUGH_PRICE_ID = "js-dough-price-by-year-graph"
const GRAPH_DOUGH_TARIF_ID = "js-dough-tarif-by-year-graph"


const ViewComparisonPeriod = ({ isMobile, activeDateCommon, setPeriodMonth, periodMonth }: {
    isMobile: boolean, activeDateCommon: any,
    setPeriodMonth: any,
    periodMonth: string,
}) => {


    const { t } = useTranslation()

    const { token } = useSelector((state: RootState) => state.auth)
    const { or_number } = useSelector((state: RootState) => state.contract)

    const { param_contract_id } = useParams<{
        param_contract_id: string;
    }>()

    const defaulPeriodFrom = moment().add(-10, 'month').format('MM-YYYY')
    const defaulPeriodTo = moment().add(1, 'month').format('MM-YYYY')

    const form: ConsFormType = {
        contract_id: Number(param_contract_id) || 0,
        periodFrom: defaulPeriodFrom,
        periodTo: defaulPeriodTo
    }


    const [sendForm, setSendForm] = useState<ConsFormType>(form);

    // sendForm
    const { currentData, error, isFetching } = useViewComparisonByYearQuery<any>(sendForm)

    const uniqueKeys = currentData?.legendKeys?.map((i: string) => {
        return ({
            key: i,
            show: true,
        })
    })
    const [legend, setLegend] = useState([]);
    useEffect(() => {
        if (isIterableArray(uniqueKeys) && !isIterableArray(legend)) {
            setLegend(uniqueKeys)
        }
    }, [uniqueKeys, legend]);



    useEffect(() => {
        if (!!activeDateCommon) {
            setFormForFetch(activeDateCommon)
        }
    }, [activeDateCommon]);

    const setFormForFetch = (values: any) => {
        setSendForm(prev => ({
            ...prev, ...{
                ...values,
                contract_id: param_contract_id
            }
        }))
    }

    const datachar = useCallback(
        () => {
            const data = currentData?.formatted
            if (!data) return
            const datasets = []
            if (isData(data.rdn) && isShowInLegend(legend, 'rdn')) datasets.push({
                animation: false,
                transitions: false,
                order: 4,
                label: t('analytics.tarifs_rdn'),
                data: data.rdn,
                backgroundColor: chartColors.rdn,
                borderRadius: 4,
                spanGaps: false,
                stack: 'Stack1',
                datalabels: {
                    display: !isMobile,
                    align: 'center',
                    // rotation: '-90',
                    anchor: 'center',
                    formatter: function (value: any) {
                        return `${toFormatPrice(value)}`;
                    },
                    color: function (context: any) {
                        if (!context?.dataset?.data?.[context?.dataIndex]) return '#00000000'
                        return '#444248';
                    },
                    font: {
                        weight: 500,
                        size: 10,
                        family: 'Inter'
                    }
                }

            })

            if (isData(data.transfer) && isShowInLegend(legend, 'transfer')) datasets.push({
                animation: false,
                transitions: false,
                order: 3,
                label: t('analytics.tarifs_transfer'),
                data: data.transfer,
                backgroundColor: chartColors.transfer,
                borderRadius: 4,
                spanGaps: true,
                stack: 'Stack1',
                datalabels: {
                    display: !isMobile,
                    align: 'center',
                    // rotation: '-90',
                    anchor: 'center',
                    formatter: function (value: any) {
                        return `${toFormatPrice(value)}`;
                    },
                    color: function (context: any) {
                        if (!context?.dataset?.data?.[context?.dataIndex]) return '#00000000'
                        return '#444248';
                    },
                    font: {
                        weight: 500,
                        size: 10,
                        family: 'Inter'
                    }
                }
            })

            if (isData(data.class1) && isShowInLegend(legend, 'class1')) datasets.push({
                animation: false,
                transitions: false,
                order: 2,
                label: t('analytics.tarifs_class1'),
                data: data.class1,
                backgroundColor: chartColors.class1,
                borderRadius: 4,
                spanGaps: true,
                stack: 'Stack1',
                datalabels: {
                    display: !isMobile,
                    align: 'center',
                    // rotation: '-90',
                    anchor: 'center',
                    formatter: function (value: any) {
                        return `${toFormatPrice(value)}`;
                    },
                    color: function (context: any) {
                        if (!context?.dataset?.data?.[context?.dataIndex]) return '#00000000'
                        return '#444248';
                    },
                    font: {
                        weight: 500,
                        size: 10,
                        family: 'Inter'
                    }
                }
            })
            if (isData(data.class2) && isShowInLegend(legend, 'class2')) datasets.push({
                animation: false,
                transitions: false,
                order: 1,
                label: t('analytics.tarifs_class2'),
                data: data.class2,
                backgroundColor: chartColors.class2,
                borderRadius: 4,
                spanGaps: true,
                stack: 'Stack1',
                datalabels: {
                    display: !isMobile,
                    align: 'center',
                    // rotation: '-90',
                    anchor: 'center',
                    formatter: function (value: any) {
                        return `${toFormatPrice(value)}`;
                    },
                    color: function (context: any) {
                        if (!context?.dataset?.data?.[context?.dataIndex]) return '#00000000'
                        return '#fff';
                    },
                    font: {
                        weight: 500,
                        size: 10,
                        family: 'Inter'
                    }
                }
            })


            if (data) return {
                labels: data?.labels_string,
                datasets: datasets
            }
        },
        [currentData?.formatted, isMobile, legend],
    )


    const handleClick = (index: number, el: any) => {
        const period = moment(currentData?.formatted?.labels?.[index], 'YYYY-MM').format('MM-YYYY')
        setPeriodMonth(period)
    }

    const saveExcel = (callback?: any) => {
        axios.post(`${baseApi}/api/analitic/build-excel-report-type-1`, {
            ...sendForm,
            typeReport: 1,
        },
            {
                responseType: 'blob',
                headers: {
                    'Authorization': token,
                }
            })
            .then((response: any) => {
                if (response.data.res === 'Error') {
                    errorToast({
                        title: t('analytics.build_excel_report'),
                        text: t('analytics.build_excel_report_error')
                    })
                }
                else {
                    fileDownload(response.data, `${t('analytics.build_excel_report_1')} ${sendForm.periodFrom} - ${sendForm.periodTo}.xlsx`)
                }
            })
            .catch(error => {
                console.error(error);
                errorToast({
                    title: t('analytics.build_excel_report'),
                    text: t('analytics.build_excel_report_error')
                })
            })
            .finally(() => {
                if (callback) callback()
            })
    }
    return (
        <div>
            <FiltersViewComparison
                value={{
                    periodFrom: sendForm.periodFrom,
                    periodTo: sendForm.periodTo,
                }}
                isLoadingFetch={isFetching}
                fetchPage={setFormForFetch}
                savePicture={() => {
                    saveGraphToPicture(GRAPH_ID, `${t('or')} ${or_number} - ${t('analytics.analytics_comparison_by_year_title')} ${t('by_period')} ${sendForm.periodFrom} - ${sendForm.periodTo}.png`)
                    // saveGraphToPicture(GRAPH_DOUGH_TARIF_ID, `${t('or')} ${or_number} - ${t('analytics.dataPriceTitle')} ${t('by_period')} ${sendForm.periodFrom} - ${sendForm.periodTo}.png`)
                    // saveGraphToPicture(GRAPH_DOUGH_PRICE_ID, `${t('or')} ${or_number} - ${t('analytics.dataTotalTitle')} ${t('by_period')} ${sendForm.periodFrom} - ${sendForm.periodTo}.png`)
                }}
                saveExcel={saveExcel}
                isForSave={!!currentData?.isForSave}
            />
            {

                currentData?.formatted ?

                    <div className='grid lap:grid-cols-[65%_35%] lap2:grid-cols-[75%_25%] gap-[24px] lap:gap-[32px]'>
                        <div className='bg-white border-2 border-gray-200 rounded-[16px] lap:rounded-[24px] p-[24px] lap:p-[32px]'>
                            <Typography variant='lead' className='text-gray-800 text-center mb-[24px] tab:mb-[32px] text-[20px] lap:text-[24px] text-left'>
                                {t('analytics.price_by_period_title')}
                            </Typography>
                            <div className={classCharWithDoughtnutContainerHeight}>
                                <GraphConsumption
                                    graphId={GRAPH_ID}
                                    datachar={datachar()}
                                    isMobile={isMobile}
                                    plugins={isMobile ? [] : [topLabels()]}
                                    fixedCount={2}
                                    isSummTooltip={true}
                                    handleClickGraph={handleClick}
                                />
                            </div>
                            {
                                !!currentData?.isForSave &&
                                    (isIterableArray(uniqueKeys) && isIterableArray(legend))
                                    ?
                                    <div className=' mt-[24px] flex gap-[8px] lap:gap-x-[16px] flex-wrap justify-start'>
                                        {
                                            legend.map((item: any, index: number) => (
                                                <div key={index} className='flex gap-[2px] items-center cursor-pointer' onClick={() => {
                                                    setLegend((prev: any) => prev.map((i: any) => ({
                                                        ...i,
                                                        show: item.key === i.key ? !i.show : i.show
                                                    })))
                                                }}>
                                                    <span className={`block rounded w-[10px] h-[10px]  `} style={{ backgroundColor: item.show ? chartColors?.[item.key] : '#eee' }}></span>
                                                    <Typography variant='lead' className={`${item.show ? 'text-gray-700' : 'text-gray-400'}  font-medium text-[12px] lap:text-[14px]`}>
                                                        {t(`analytics.legend_${item.key}`)}
                                                    </Typography>
                                                </div>
                                            ))
                                        }
                                    </div>
                                    :
                                    <div className='min-h-[45px]' />
                            }
                        </div>
                        <div className={`h-full bg-white border-2 border-gray-200 rounded-[16px] lap:rounded-[24px] p-[24px] lap:p-[32px] min-h-[400px]`}>
                            <ViewByPeriodDetailing
                                periodFrom={sendForm.periodFrom}
                                periodTo={sendForm.periodTo}
                                graphTarifId={GRAPH_DOUGH_TARIF_ID}
                                graphPriceId={GRAPH_DOUGH_PRICE_ID}
                            />
                        </div>
                    </div>
                    :
                    isFetching ?
                        <div className='grid lap:grid-cols-[65%_35%] lap2:grid-cols-[75%_25%] gap-[24px] lap:gap-[32px]'>
                            <div className={`bg-white border-2 border-gray-200 rounded-[16px] lap:rounded-[24px] p-[24px] lap:p-[32px] ${classCharWithDoughtnutContainerHeight} flex justify-center items-center`}>
                                <Spinner />
                            </div>
                            <div className={`h-full bg-white border-2 border-gray-200 rounded-[16px] lap:rounded-[24px] p-[24px] lap:p-[32px] min-h-[400px] flex justify-center items-center`}>
                                <Spinner />
                            </div>
                        </div>
                        :
                        error ?
                            <TableLayout>
                                <Typography variant='lead' className='text-[16px] lap:text-[20px] font-medium text-center my-[40px]'>
                                    {t('tables.error_on_loading')}
                                </Typography>
                            </TableLayout>
                            :
                            ''
            }

        </div>
    )
}

export default ViewComparisonPeriod